import "./App.css";

function App() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        padding: "20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          padding: "40px",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ fontSize: "48px", marginBottom: "20px" }}>🔧</div>
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "600",
            color: "#333",
            marginBottom: "16px",
          }}
        >
          We'll be right back
        </h1>
        <p
          style={{
            fontSize: "18px",
            color: "#666",
            lineHeight: "1.6",
            marginBottom: "24px",
          }}
        >
          We're currently performing scheduled maintenance to improve your experience. We'll be back online shortly.
        </p>
        <p
          style={{
            fontSize: "14px",
            color: "#999",
          }}
        >
          Thank you for your patience.
        </p>
      </div>
    </div>
  );
}

export default App;
